<template>
<div class="modal fade" id="changePassModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
   <div class="modal-dialog">
      <div class="modal-content">

         <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Cambiar Contraseña de "<strong>{{currentUser.username}}</strong>"</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="btnClose"></button>
         </div>

         <div class="modal-body">
            <Form class=" mt-10" @submit="changePass" >

               <Field_l_fe :schema="changePassSchema" />

               <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
                  {{ message }}
               </div>
               <div class="d-flex align-items-end flex-column">
                  <button v-if="!successful" type="submit" class="btn btn-primary col-sm-8" :disabled="loading">
                     <span v-show="loading"  class="spinner-border spinner-border-sm"></span>
                     Cambiar Contraseña
                  </button>
                  <button v-show="false" type="reset" class="btn btn-secondary mt-1 col-sm-3" ref="btnReset">Reset</button>
                  <button v-if="successful" type="button" class="btn btn-secondary mt-1 col-sm-3" @click="clearForm">Aceptar</button>
               </div>
            </Form>
         </div>

      </div>
   </div>
</div>
</template>

<script>
import { Form, defineRule } from "vee-validate";
import * as yup from 'yup';
import Field_l_fe from './Field-l-fe.vue';
import AuthService from '../services/auth.service';

defineRule("confirmed", (value, [other]) => {
   if (value !== other) {
      return '¡Las contraseñas no coinciden!';
   }
   return true;
});

export default {
   name: 'MdChangePass',
   components: {
      Form,
      Field_l_fe,
   },
   data() {
      return {
         successful: false,
         loading: false,
         message: "",
      };
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      changePassSchema() {
         let schema = {
         classDivCont: "form-group row mb-1",
         classLabel: "col-sm-4",
         classDivField: "d-flex align-items-end flex-column col-sm-8",
         fields: [
            {
               id: 1,
               label: 'Nueva Contraseña',
               name: 'password',
               type: 'password',
               rules: yup.string().required("¡Se requiere contraseña!")
                     .min(6, "¡Debe tener al menos 6 caracteres!")
                     .max(40, "¡Debe tener un máximo de 40 caracteres!"),
            },
            {
               id: 2,
               label: 'Repetir Contraseña',
               name: 'password2',
               type: 'password',
               rules:'confirmed:@password',
            },
         ],
         };
         return schema;
      },
   },
   created() {
      if (!this.currentUser) {
         this.$router.push("/login");
      }
   },
   methods: {
      clearForm:function() {
         this.successful = false;
         this.loading = false;
         this.message = "";
         this.$refs.btnReset.click();
         this.$refs.btnClose.click();
      },
      changePass(user) {
         //console.log(user);        
         this.message = "";
         this.successful = false;
         this.loading = true;
         user.username = this.currentUser.username;
         //console.log(user);
         AuthService.changePass(user)
         .then(response => {
            this.message = response.data.message;
            this.successful = true;
            this.loading = false;
            console.log(response.data);
         })
         .catch(error => {
            this.message =
               (error.response &&
               error.response.data &&
               error.response.data.message) ||
               "Error de sistema (ChangePass): " + error.message ||
               error.toString();
            this.successful = false;
            this.loading = false;
            //console.log(error);
         });         
      }
   }
}
</script>
